import { useState } from 'react'

export const useHandleEdit = ({
  isEditingTable = false,
  setIsEditingTable = () => {},
}) => {
  const [isEdit, setIsEdit] = useState(false)

  const handleEditMode = flag => {
    if (isEditingTable && flag) {
      return
    }

    setIsEditingTable(flag)
    setIsEdit(flag)
  }

  return { isEdit, handleEditMode }
}

export default useHandleEdit
